<template lang="pug">
  v-btn(
    v-if="false"
    class="main-button"
    @click="openUploadDialog"
  ) {{ $t('Create') }}
  e-button-upload-file(
    v-else
    ref="uploader"
    :validation-rules="rules"
    :accept="acceptedFileExtensions"
    multiple
    button-class="w-100"
    :loading="loading"
    @onload="upload"
  )
    span {{ $t('Create') }}
</template>

<script>
import Base64js from 'base64-js'
import contentDialog from '~/mixins/dialogs/contentDialog'
import converters from '~/mixins/methods/converters'
import EButtonUploadFile from '~/components/elements/buttons/e-button-upload-file'
import upload from '~/modules/templates/mixins/upload'

export default {
  name: 'EButtonTemplateUpload',
  components: {
    EButtonUploadFile
  },
  mixins: [upload, converters, contentDialog],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async upload(files) {
      const { valid, errors } = await this.$refs.uploader.validate(files)
      if (!valid) {
        const errMessage = this._.get(errors, '[0]')
        this.$notification.error(errMessage)
        return
      }
      try {
        this.loading = true
        for (const file of files) {
          const arrayBuffer = await this.blobToArrayBuffer(file)
          const uint8View = new Uint8Array(arrayBuffer)
          const base64Str = Base64js.fromByteArray(uint8View)
          try {
            const payload = {
              fileContent: base64Str,
              filename: file?.name,
              title: file?.name.split('.').slice(0, -1).join('.')
            }
            const templateId = this._.get(
              await this.$store.dispatch('templates/create', { payload }),
              'id'
            )
            if (files && files.length === 1 && templateId) {
              await this.$router.push({
                path: `/templates/${templateId}`,
                query: { status: 'new' }
              })
              return
            }

            this.$notification.success(
              this.$t('{document} has been successfully uploaded', { document: file.name })
            )
          } catch (e) {
            const message = this._.get(e, 'response.data.message')
            this.$notification.error(
              this.$t('Error occurred with {document} - {error}', {
                document: file.name,
                error: message
              })
            )
          }
        }
        await this.$store.dispatch('templates/getAll', {
          config: {
            params: this.$store.getters['templates/requestParams']
          }
        })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    },
    openUploadDialog() {
      this.contentDialog.open({
        component: 'm-template-upload',
        width: '900px'
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
